import React from "react";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import { PropTypes } from "prop-types";

class UserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  render() {
    return (
      <div>
        <Rodal
          visible={this.props.open}
          onClose={this.props.close}
          width={Number(this.props.width)}
          height={Number(this.props.height)}
          customStyles={this.props.customStyles}
        >
          <div style={{ paddingTop: "5px" }}>{this.props.children}</div>
        </Rodal>
      </div>
    );
  }
}

UserModal.propTypes = {
  open: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  close: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string
}

export default UserModal;
